import useTrans from "@/hooks/useTrans";
import { useCartContext } from "@/setup/cartProvider";
import { Box, Grid, TextInput, UnstyledButton } from "@mantine/core";
import React, { useState } from "react";
import useStyles from "../../styles/CartRightSection";

function AddVoucher() {
  const [voucher, setVoucher] = useState("");
  const { classes } = useStyles();
  const { addVoucher } = useCartContext();

  const onValueChange = (event) => {
    setVoucher(event.currentTarget.value);
  };

  const submitVoucher = async () => {
    // await checkVoucher(voucher);

    await addVoucher(voucher);
  };
  const trans = useTrans();
  function RightSectionInputVoucher() {
    return (
      <UnstyledButton
        onClick={submitVoucher}
        className={classes.btnSubmitVoucher}
      >
        {trans?.cart.accept}
      </UnstyledButton>
    );
  }

  return (
    <Grid.Col md={12} lg={12}>
      <Box
        className={classes.container}
        style={{ paddingBottom: 20, paddingTop: 20 }}
      >
        <TextInput
          size="md"
          rightSection={<RightSectionInputVoucher />}
          rightSectionWidth={100}
          value={voucher}
          onChange={onValueChange}
          label={trans?.cart.voucher}
          placeholder={trans?.cart.chooseVoucher}
        />
      </Box>
      {/* {listVouchers.length > 0 && <Text>{listVouchers[0].ma_voucher}</Text>} */}
    </Grid.Col>
  );
}

export default AddVoucher;
